/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'heavy',
    quality: 0.15,
    toughness: 3,
    speed: -0.6
}